import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OutsourcedJobLinkService from '../../../Services/OutsourcedJobLinkService';
import ChangeFieldworkOfficeItem from '../../../Domain/ChangeFieldworkOfficeItem';

class ChangeFieldworkOfficeWindowDescription extends React.Component {
  static titleForEdit = 'Change Bill To Office';
  static itemType = ChangeFieldworkOfficeItem;
  static serviceFunction = (editedItem) =>
    OutsourcedJobLinkService.ChangeFieldworkOffice(
      editedItem.OutsourcedJobLinkIds,
      editedItem.NewFieldworkOfficeId,
      editedItem.AllItemsSelected,
      editedItem.SearchItem
    );

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'NewFieldworkOfficeId',
          label: 'New Bill To Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          showFilterAt: 9999,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}

export default ChangeFieldworkOfficeWindowDescription;
